export var setRef = function setRef(forwardedRef, ref) {
  if (forwardedRef && 'current' in forwardedRef) {
    forwardedRef.current = ref;
  } else if (forwardedRef) {
    forwardedRef == null ? void 0 : forwardedRef(ref);
  }
};
export var refDefined = function refDefined(ref) {
  return ref && ref.current;
};
export var refContainsTarget = function refContainsTarget(ref, target) {
  return ref && ref.current && ref.current.contains(target);
};
export var refParentContainsTarget = function refParentContainsTarget(ref, target) {
  return ref && ref.current && ref.current.parentNode && ref.current.parentNode.contains(target);
};